import React, { useEffect, useState } from "react";
import { FiSave } from "react-icons/fi";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import PerfectScrollbar from "react-perfect-scrollbar";
import Footer from "../shared/Footer";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const MASK_VALUE = "********"; // Mask değeri

const SettingApiForm = () => {
    const [apiSettings, setApiSettings] = useState({
        mailjet_title: "",
        mailjet_secret: "",
        mailjet_api: "",
        s3_cdn_key: "",
        s3_cdn_secret: "",
        s3_cdn_endpoint: "",
        s3_cdn_bucket: "",
        s3_cdn_region: "",
        s3_cdn_path: "",
        paytr_merchant_id: "",
        paytr_merchant_key: "",
        paytr_merchant_salt: "",
        netgsm_username: "",
        netgsm_password: "",
        invoice_title: "",
        invoice_address: "",
        invoice_phone: "",
        tax_rate: 20,
    });

    const language = useUserLanguage();
    const { translations } = useTranslations(language);
    const getText = (key, defaultValue) => translations[key] || defaultValue;

    // API verilerini ilk render’da çek
    useEffect(() => {
        fetchApiData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // API'den verileri çekip, hassas alanları maskeler
    const fetchApiData = async () => {
        try {
            const resp = await axios.get(`${BASE_URL}/api/settings/1`); // id=1 olan kaydı alıyoruz
            console.log("Gelen API Data:", resp.data);
            const data = resp.data || {};

            // Eğer mailjet_secret değeri varsa, bunu maskeyle gösteriyoruz.
            if (data.mailjet_secret && data.mailjet_secret !== "") {
                data.mailjet_secret = MASK_VALUE;
            }
            // Diğer hassas alanlar için de aynı mantığı uygulayabilirsiniz.
            if (data.s3_cdn_secret && data.s3_cdn_secret !== "") {
                data.s3_cdn_secret = MASK_VALUE;
            }
            if (data.paytr_merchant_key && data.paytr_merchant_key !== "") {
                data.paytr_merchant_key = MASK_VALUE;
            }
            if (data.paytr_merchant_salt && data.paytr_merchant_salt !== "") {
                data.paytr_merchant_salt = MASK_VALUE;
            }
            if (data.netgsm_password && data.netgsm_password !== "") {
                data.netgsm_password = MASK_VALUE;
            }

            setApiSettings((prevState) => ({
                ...prevState,
                ...data,
            }));
        } catch (err) {
            console.error("API verisi çekme hatası:", err);
            toast.error("API ayarları alınamadı!");
        }
    };

    // Input değişikliklerini handle etme
    const handleChange = (e) => {
        const { name, value } = e.target;
        setApiSettings((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Hassas alanlarda (password tipi) odaklanınca maskeyi temizle
    const handleSecretFocus = (e) => {
        if (e.target.value === MASK_VALUE) {
            e.target.value = "";
            // Güncelleme state'te de maskeyi kaldırıyoruz
            setApiSettings((prev) => ({
                ...prev,
                [e.target.name]: "",
            }));
        }
    };

    // Kaydet butonuna basınca API'yi güncelle
    const handleSave = async () => {
        try {
            // Backend'e gönderilecek veriyi hazırlarken, eğer alan maskeyi içeriyorsa
            // yani kullanıcı o alanı değiştirmediyse, o alanı güncelleme dışında bırakıyoruz.
            const dataToSave = { ...apiSettings };

            if (dataToSave.mailjet_secret === MASK_VALUE) {
                delete dataToSave.mailjet_secret;
            }
            if (dataToSave.s3_cdn_secret === MASK_VALUE) {
                delete dataToSave.s3_cdn_secret;
            }
            if (dataToSave.paytr_merchant_key === MASK_VALUE) {
                delete dataToSave.paytr_merchant_key;
            }
            if (dataToSave.paytr_merchant_salt === MASK_VALUE) {
                delete dataToSave.paytr_merchant_salt;
            }
            if (dataToSave.netgsm_password === MASK_VALUE) {
                delete dataToSave.netgsm_password;
            }
            // Diğer hassas alanları da kontrol edebilirsiniz...

            await axios.put(`${BASE_URL}/api/settings/1`, dataToSave);
            toast.success(getText("SUCCESS_API_UPDATED"));
            fetchApiData(); // Güncellenmiş verileri tekrar çek
        } catch (error) {
            console.error("API Bilgileri kaydedilemedi:", error);
            toast.error("Kayıt hatası oluştu!");
        }
    };

    return (
        <div className="content-area setting-form">
            <ToastContainer />
            <PerfectScrollbar>
                <PageHeaderSetting />
                <div className="content-area-body">
                    <div className="card mb-0">
                        <div className="card-body">
                            <div className="mb-3">
                                <label className="form-label fw-bold">
                                    {getText("LABEL_TAX_RATE")}
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="tax_rate"
                                    value={apiSettings.tax_rate ?? ""}
                                    onChange={(e) => {
                                        let value = e.target.value;

                                        if (value < 0) value = 0;
                                        if (value > 100) value = 100;

                                        setApiSettings((prev) => ({
                                            ...prev,
                                            tax_rate: value,
                                        }));
                                    }}
                                    min="0"
                                    max="100"
                                    step="0.01"
                                    placeholder="20"
                                />

                                <small className="text-muted">
                                    ex: 20 = %20, 10 = %10
                                </small>
                            </div>


                            {/* KAYDET BUTONU */}
                            <div className="d-flex justify-content-center">
                                <button className="btn btn-primary" onClick={handleSave}>
                                    <FiSave className="me-2" /> {getText("SAVE_BTN")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </PerfectScrollbar>
        </div>
    );
};

export default SettingApiForm;
